module.exports = __webpack_public_path__ + "static/media/23.4d30fd51.webp";